import appInfo from './appInfo'

// 声明全局回调
const WEB_CALLBACK = []
const onSuccessCache = Object.create(null)
const onFailCache = Object.create(null)

window.WEB_CALLBACK = WEB_CALLBACK

window.onSuccess = function(params, callbackParams) {
  console.info('onSuccess', params, callbackParams)
  if (onSuccessCache[callbackParams]) {
    onSuccessCache[callbackParams](params)
  }
}

window.onFail = function(params, callbackParams) {
  console.info('onFail', params, callbackParams)
  if (onFailCache[callbackParams]) {
    onFailCache[callbackParams](params)
  }
}

/**
 * 回调函数代理
 */
const callbackProxy = (params = {}, callbackName = 'callback') => {
  const middlewareCallback = params.callback || function() {}

  const callback = json => {
    if (typeof json === 'string') {
      json = JSON.parse(json)
    }

    if (middlewareCallback) {
      middlewareCallback(json)
    }
  }

  if (params.onSuccess || params.onFail) {
    const timeStr = new Date().getTime() + ''
    params.callbackParams = timeStr
    onSuccessCache[timeStr] = params.onSuccess || function() {}
    onFailCache[timeStr] = params.onFail || function() {}
  } else {
    params[callbackName] = `WEB_CALLBACK[${WEB_CALLBACK.push(callback) - 1}]`
  }

  if (params.onSuccess) {
    delete params.onSuccess
  }

  if (params.onFail) {
    delete params.onFail
  }

  return params
}

/**
 * 和客户端的通用交互方法
 *
 * @param {string} name - 交互方法的名称
 * @param {object} [params={}] - 所传参数
 * @returns
 */
/*  eslint-disable no-unused-vars */
const EMJSBridge = (name, params = {}) => {
  return new Promise((resolve, reject) => {
    // 超时
    let timeout = null

    const executeNative = () => {
      clearTimeout(timeout)

      const middlewareCallback = params.callback || function() {}

      const callback = json => {
        let result = json

        if (typeof params === 'string') {
          result = JSON.parse(params)
        }

        if (middlewareCallback) {
          middlewareCallback(result)
        }
        resolve(result)
      }

      params.callback = `WEB_CALLBACK[${WEB_CALLBACK.push(callback) - 1}]`

      window.goods[name](JSON.stringify(params))
    }

    if (typeof goods !== 'undefined' && window.goods[name]) {
      executeNative()
    } else {
      const errorMsg = 'goods or goods.' + name + ' is undefined!'

      console.warn(errorMsg)

      const waitTime =
        typeof params.timeOut === 'undefined' ? 1000 : params.timeOut
      // 如果1s内未触发 goodsReady 事件，则视为失败
      timeout = setTimeout(() => {
        reject(errorMsg)
      }, waitTime)

      // 监听ios goodsReady事件
      document.addEventListener('goodsReady', executeNative)
    }
  })
}

/**
 * 与客户端的交互方法集合
 *
 * @class ym
 */
class ym {
  /**
   * 调用客户端的登录
   * @param {string} [url=location.href] - 登录成功后跳转的地址
   */
  static login(type = 2) {
    console.info('匿名用户跳转登录页面')
    this.openurl(`skstock://login?type=${type}`)
  }

  /**
   * 调用客户端的绑定手机号
   */
  static bindPhone() {
    console.info('实名未绑定手机号跳转绑定手机号页面')
    this.openurl('skstock://phonebind')
  }

  /**
   * 保留当前页面，在新的webview中打开页面
   * @param {string} url 要打开的页面地址
   */
  static openurl(url, data) {
    if (!url) {
      console.error('请传入要打开的页面地址')
      return
    }

    if (url.indexOf('http://') === -1 && url.indexOf('https://') === -1) {
      location.href = url
      return
    }

    if (typeof window.goods !== 'undefined' && window.goods.openurl) {
      if (data) {
        window.goods.openurl(url, data)
      } else {
        window.goods.openurl(url)
      }
    } else {
      const search = location.search
      // let url = params.url;
      if (url.indexOf('?') > -1) {
        url = url + search.replace('?', '&')
      } else {
        url = url + search
      }
      // 使用原生打开失败时，尝试使用location直接跳转
      location.href = url
    }
  }

  /**
   * 使用系统或第三方浏览器打开网页
   * @param {String} url 网页地址
   */
  static openBrowser(url) {
    location.href = `skstock://browser?thirdapp=true&url=${encodeURI(url)}`
  }

  /**
   * 关闭当前页面（webview）
   */
  static goback() {
    if (window.goods) {
      if (window.goods.goback) {
        window.goods.goback()
      } else if (window.goods.closeWebPage) {
        window.goods.closeWebPage()
      } else {
        console.info('goods.goback and goods.closeWebPage are undefined')
      }
    } else {
      console.warn('goods or goods.goback is undefined')
    }
  }

  /**
   * 轻提示（弹出类似于toast的提示框）
   * @param {string} text - 提示的内容
   */
  static showNotify(text) {
    if (window.goods) {
      if (window.goods.showNotify) {
        window.goods.showNotify(text)
      } else if (window.goods.showTips) {
        window.goods.showTips(text)
      } else {
        console.info('goods.showNotify and goods.showTips are undefined')
      }
    } else {
      console.info('goods or goods.showNotify is undefined')
    }
  }

  /**
   * 打开微信
   */
  static openWechat() {
    if (window.goods && window.goods.openApp && appInfo.platform.Android) {
      window.goods.openApp(
        JSON.stringify({ pkg: 'com.tencent.mm', url: 'weixin://' })
      )
    } else {
      location.href = `skstock://browser?thirdapp=true&url=${encodeURIComponent(
        'https://appstatic.emoney.cn/html/open-wechat/index.html'
      )}`
    }
  }

  /**
   * 打开大图
   * @param {string} imageUrl 图片地址
   */
  static openImageBrowser(imageUrl) {
    if (imageUrl) {
      // 小图换成大图
      imageUrl = imageUrl.replace('_small.', '_big.')
    }

    console.info('[ym.openImageBrowser]: 打开大图', imageUrl)

    if (window.goods && window.goods.openImageBroswer) {
      window.goods.openImageBroswer(
        JSON.stringify({
          imgUrl: imageUrl,
          startX: 0,
          startY: 0,
          imgWidth: 100,
          imgHeight: 100
        })
      )
    } else {
      console.info('goods or goods.openImageBroswer is undefined')
    }
  }

  /**
   * @typedef PlayVideoOptions
   * @property { string } videoId 视频id，如果为url，则会尝试自动从url中截取
   * @property { number } [type=0] 视屏类型(0:竖屏，1：横屏)
   * @property { string } [videoName] 视频名称，即视频播放页面的标题
   * @property { string } [category] 视频分类，用于识别并显示视频下面的网页url
   * @property { boolean } [float] 是否启用窗口播放
   */

  /**
   * 播放视频，使用原生播放器
   * @param { PlayVideoOptions } options
   * @param { Object } [params] 自定义参数
   */
  static playVideo(options, params) {
    let videoId = options.videoId

    if (/^http/.test(options.videoId)) {
      videoId = /-([a-z0-9]+)$/i.exec(options.videoId)[1]
    }

    if (options.category) {
      videoId += `,category:${options.category}`
    }

    if (options.videoName) {
      videoId += `,VideoName:${encodeURIComponent(options.videoName || '视频')}`
    }

    if (params) {
      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
          videoId += `,${key}:${params[key]}`
        }
      }
    }

    const url = `skstock://playvideo?id=${videoId}&float=${!!options.float}&type=${options.type ||
      0}`

    console.info('[native] 播放视频：', url)

    location.href = url
  }

  /**
   * 打开多个个股的行情
   * @param {Array<string|number>} stockids 股票代码列表
   * @param {string|number} stockid 当前股票代码
   */
  static openstocks(stockids, stockid) {
    let codeIndex = stockids.indexOf(stockid)
    if (codeIndex < 0 || codeIndex > stockids.length - 1) {
      codeIndex = 0
    }

    const url = `skstock://stock?codes=${stockids}&index=${codeIndex}`
    console.info('[native] 打开股票：', url)

    location.href = url
  }

  /**
   * 打开个股行情
   * @param {string|number} stockid 股票代码
   */
  static openstock(stockid) {
    this.openstocks([stockid])
  }

  /**
   * @callback isGoodsAddedZxgCallback
   * @param {Array<number>} goodsIds 加入自选股的股票代码jsonArray
   */

  /**
   * @typedef isGoodsAddedZxgOption
   * @property {Array<number>} goodsIds 需要判断是否加入自选股的股票id，[600600, 600100, 600300]
   * @property {isGoodsAddedZxgCallback} callback 客户端判别之后的回调
   */

  /**
   * 是否已添加到自选股
   * @param {isGoodsAddedZxgOption} option
   */
  static isGoodsAddedZxg(option) {
    if (window.goods && window.goods.isGoodsAddedZxg) {
      window.goods.isGoodsAddedZxg(JSON.stringify(callbackProxy(option)))
    } else {
      console.info('goods or goods.isGoodsAddedZxg is undefined')
    }
  }

  /**
   * @typedef controlZxgOption
   * @property {number} type 操作类型(1:增加， 2:删除)
   * @property {Array<number>} goodsIds 股票id列表[600600, 600100, 600300]
   * @property {Function} onSuccess 成功回调
   * @property {Function} onFail 失败回调
   */

  /**
   * 添加/删除 自选股
   * @param {controlZxgOption} option
   */
  static controlZxg(option) {
    if (window.goods && window.goods.controlZxg) {
      window.goods.controlZxg(JSON.stringify(callbackProxy(option)))
    } else {
      console.info('goods or goods.controlZxg is undefined')
    }
  }

  /**
   * 显示提示对话框
   * @param {Object} option 参数
   * @param {string} option.title 标题（可选参数，默认无标题）
   * @param {string} option.content 对话框内容文本
   * @param {number} option['align-content'] 对话框内容文本对齐方式，0：左对齐 1：水平居中对齐， 默认为0
   * @param {string} option.button 按钮文字
   */
  static showTipsDialog(option) {
    if (window.goods && window.goods.showTipsDialog) {
      window.goods.showTipsDialog(JSON.stringify(option))
    } else {
      console.info('goods or goods.showTipsDialog is undefined')
    }
  }

  /**
   * 右上角菜单配置
   * @typedef MenuItem
   * @property {string} title 标题
   * @property {string} tintColor 颜色
   * @property {Function} callback 点击回调
   */

  /**
   * 显示右上角菜单
   * @param {{menuItems:Array<MenuItem>}} options 菜单配置
   */
  static showMenuItems(options) {
    const menuItems = []
    options.menuItems.forEach(item => menuItems.push(callbackProxy(item)))

    if (window.goods && window.goods.showMenuItems) {
      console.info(
        '[native] goods.showMenuItems',
        JSON.stringify({ menuItems })
      )
      window.goods.showMenuItems(JSON.stringify({ menuItems }))
    } else {
      console.info('goods.showMenuItems are undefined', { menuItems })
    }
  }

  /**
   * 微信分享弹窗是否可用
   */
  static isSharePopEnable() {
    return (
      window.goods && window.goods.showMenuItems && window.goods.showSharePop
    )
  }

  /**
   * 微信分享弹窗
   */
  static showSharePop(param) {
    if (this.isSharePopEnable()) {
      window.goods.showSharePop(JSON.stringify(param))
    }
  }
}

if (typeof window !== 'undefined') {
  window.ym = ym
}

export default ym
